import React, { useEffect, useState } from 'react';
import { Image, Stack } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import leptopAmazon from "../../../../assets/images/leptop-amazon-com.png";
import leptopMixt from "../../../../assets/images/leptop-mixt.png";
import leptopShopify from "../../../../assets/images/leptop-shopify.png";
import Logo from "../../../../assets/images/logo.svg";
import SvgIcons from '../../../../components/common/SvgIcons';
import { salesChannelService } from '../services';

const SalesChannelCallback: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [channelName, setChannelName] = useState<string>('');

    const closeCallbackPage = () => {
        localStorage.removeItem('installationUrl');
        localStorage.removeItem('reinstallationUrl');
        // Set flag so listing page applies Active status filter when redirecting from callback
        localStorage.setItem('salesChannelStatusFilter', '1');
        if (window.opener) {
            window.opener.focus();
        }
        window.close();
        // Browsers often block close() after OAuth redirect. If tab is still open, redirect to sales channel listing.
        setTimeout(() => {
            const salesChannelListingUrl = `${window.location.origin}/app/settings/sales-channels`;
            window.location.replace(salesChannelListingUrl);
        }, 150);
    };

    const addShopifyPlateform = async (shopifyDetails: any) => {
        const shopify = await salesChannelService.installationShopifySalesChannel(shopifyDetails);

        if (shopify?.statusCode === 200 && shopify?.status === 'success') {
            closeCallbackPage();
        }
    }

    const addAmazonPlateform = async (amazonDetails: any) => {
        try {
            const amazon = await salesChannelService.amazonCallback(amazonDetails);

            if (amazon?.statusCode === 200) {
                closeCallbackPage();
            }
        } catch (error) {

        }
    }

    // const sessionTokenData = async () => {
    //     console.log('In this function');
    //         const host: string = searchParams?.get('host') || '';

    //         console.log('Host: ======>', host);

    //         const app = createApp({
    //             apiKey: "6019de515a0bd0287e4707aa2459d8f0", // API key from the Partner Dashboard
    //             host: host, // host from URL search parameter
    //             forceRedirect: true
    //         });
    
    //         console.log('App: =====>', app);
    
    //         getSessionToken(app).then((sessionToken: any) => {
    //             console.log('Session token: =====>', sessionToken);

    //             const shopifyDetails = {
    //                 code: searchParams.get('code') || '',
    //                 shop: searchParams.get('shop'),
    //                 hmac: searchParams.get('hmac'),
    //                 state: searchParams.get('state') || '',
    //                 timestamp: searchParams.get('timestamp'),
    //                 host: searchParams.get('host'),
    //                 session_token: sessionToken
    //             }

    //             addShopifyPlateform(shopifyDetails);
    //         });
    // }

    useEffect(() => {

        if (searchParams.get('selling_partner_id')) {
            setChannelName('Amazon');
            const amazonDetails = {
                spapi_oauth_code: searchParams.get('spapi_oauth_code'),
                state: searchParams.get('state'),
                selling_partner_id: searchParams.get('selling_partner_id')
            };

            addAmazonPlateform(amazonDetails);
        } else {
            setChannelName('Shopify');

            const shopifyDetails = {
                code: searchParams.get('code') || '',
                shop: searchParams.get('shop'),
                hmac: searchParams.get('hmac'),
                state: searchParams.get('state') || '',
                timestamp: searchParams.get('timestamp'),
                host: searchParams.get('host'),
            }

            addShopifyPlateform(shopifyDetails);
        }
    }, [searchParams]);

    return (
        <div className='vh-100 bg-body-tertiary overflow-auto d-flex align-items-center'>
            <div className='text-center m-auto p-3'>
                <div className="mb-5">
                    <Image
                        fluid
                        className="pe-none"
                        src={Logo}
                        alt="Logo"
                        width={174}
                        height={60}
                    />
                </div>
                <h4 className='fw-semibold custom-font-size-24'>Authorization under process...</h4>
                <h6>Please do not close or refresh the browser.</h6>
                <Stack direction='horizontal' gap={3} className="pt-4 mt-3 pe-none">
                    <Image
                        fluid
                        src={channelName === 'Shopify' ? leptopShopify : leptopAmazon}
                        alt={`Authorization is in under process for ${channelName}`}
                        className="user-select-none"
                        width={150}
                        height={150}
                    />
                    <span className='mx-1'>
                        {SvgIcons.transferIcon}
                    </span>
                    <Image
                        fluid
                        src={leptopMixt}
                        alt={`Authorization is in under process with ${channelName} to Mixt`}
                        className="user-select-none"
                        width={150}
                        height={150}
                    />
                </Stack>
            </div>
        </div>
    )
}
export default SalesChannelCallback;
